/* ============================================================================
   BB-STOCK-FIRSTPAINT-20261030 · 「展示库存」引擎（首屏同步版）
   ----------------------------------------------------------------------------
   为什么单独拆成一个资源：brand.js 是 defer（整篇 HTML 解析完才执行），
   而商品卡上的 "Only N left" 必须**先于首次绘制**写好。否则客户先看到 Liquid 直出的
   真实库存（如 "19 in stock"），过一会儿才被改写成渲染值 —— 就是侯哥 2026-10-30 19:5x
   报的「首次进入这个合集，渲染库存会是其他数字，然后过一会儿才变成渲染数字」。

   本文件在 theme.liquid 的 <head> 里**同步加载（无 defer）**，
   ⇒ HTML 解析到商品卡时 window.BBStock 已经存在；
   ⇒ Liquid 侧不再打印任何库存数字，各列表后面用一行内联脚本立刻上色。
   实现全站只有这一份：brand.js 里的同名块已加 `if (window.BBStock) return;` 兜底。

   原有四道铁律一字未改（显示值≤真值 / 真售罄优先 / 同一 slot 内锁死 / 只降不升）。
   ============================================================================ */
/* ============================================================================
   BB-STOCK-20261029 —— 前端「展示库存」引擎（侯哥 2026-10-29 11:2x 定制）
   ----------------------------------------------------------------------------
   需求：后台真实库存 292 的卡，前端不要写 "292 in stock"（一点都不稀缺）。
        全站显示值压到 20 以下，按热度动态变化，营造「马上卖完」。
        真实库存仍是唯一权威：真售罄必须照实显示，绝不能用编造数字挡住购买。

   铁律（四道必须守住）：
     ① 显示值 = min(公式值, 真实库存) —— 永远不超过真值，客户点买的件数永远买得到
     ② 真实库存为 0 / 不可售 ⇒ Sold out 优先，公式完全让位
     ③ 同一业务日内显示值锁死：客户刷新 100 次、来回点 10 次都不变（变了就是穿帮）
     ④ 跨业务日只降不升；补货回填幅度 <= 3 且间隔 >= 28 天（避免"刷新一下涨回去"）

   为什么按【天】衰减而不是按【浏览次数】：
     一个客户站在 PDP 上反复看，如果每看一次掉一件，3 分钟就能从 9 掉到 1，
     再掉就没了 —— 那不叫紧迫，那叫假。所以单次停留内数字纹丝不动，
     只有跨过美西 0 点（CUT_TZ=-8，与后台 GMV 重置同一时区）才掉 1。
     「一直看一个商品看到没有」的解法：掉到 1 就停在那，进入 30 天补货周期，
     周期到了从 top 重新开始（各卡按 handle 哈希错开，不会全站同一天一起涨）。

   热度源：ERP 销量（#bbHeatData 第一项），取全店百分位 0..1。
     热门卡起点低、掉得快（8~10 天见底）；冷门卡起点高、掉得慢（30 天见底）。
     ⇒ 客户看到「这张卡别人都在买，剩得越来越少」，且每张卡的数字都不一样。

   调试：任意页面加 ?stock=real ⇒ 本次会话全站直出真实库存（内部对账用，存 sessionStorage）。
   ============================================================================ */
(function () {
  'use strict';

  /* 幂等：已经由前一份（brand.js 兜底 / 本文件重复执行）定义过就直接返回 */
  if (window.BBStock && window.BBStock.apply) return;

  var CAP = 19;          /* 显示值硬上限（池子模型下实测最大 pool+1 = 10，这里是保险） */
  /* FLOOR = 2：渲染值永远不说「Only 1 left」—— 那一句只留给真实库存真的为 1 的卡。
     否则一张真实库存 115 的卡会因为渲染走到低位而挂着「最后一件」，客户买掉之后立刻归零，
     看起来像卖光了，其实仓库里还有一百多张。渲染归零 ≠ 真实售罄，这两件事必须彻底分开。 */
  var FLOOR = 2;
  var LOW_AT = 10;       /* <=10 用 "Only N left" */
  /* 真实库存 ≤2 时直接说真话（不再渲染）。这种卡马上会被 inv-sync 摘掉，
     再编数字没有意义，反而容易让客户点了买不到。 */
  var STOCK_TRUTH = 2;
  var CUT_TZ = -8;       /* 美西（保留：业务日口径，与后台 GMV 重置一致） */
  /* 池子走一格的间隔。
     BB-STOCK-PUNCH-20261029：12 → **8 分钟**。客人逛一圈回来数字就动了，
     但又不至于刷新一次变一个数（同一格内绝对稳定）。
     一个完整循环（pool=6）＝ 48 分钟，一天转 30 轮。 */
  var TICK = 8 * 60 * 1000;

  var forceReal = false;
  try {
    if (/[?&]stock=real\b/.test(location.search)) sessionStorage.setItem('bbs_real', '1');
    forceReal = sessionStorage.getItem('bbs_real') === '1';
  } catch (e) {}

  /* FNV-1a：同一 handle 永远得到同一个 0..1，保证「这张卡天生剩几件」是固定的 */
  function h01(s) {
    var h = 2166136261, i;
    s = String(s || '');
    for (i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
    return ((h >>> 0) % 1000003) / 1000003;
  }

  /* 业务日序：美西 UTC-8 的 0 点换日 */
  function dayIdx(ms) { return Math.floor((ms / 1000 + CUT_TZ * 3600) / 86400); }

  /* ---- 热度百分位（懒算一次，全店排序） ---- */
  var heatM = null;
  function heatMap() {
    if (heatM) return heatM;
    heatM = {};
    try {
      var raw = window.__bbHeatData;
      if (!raw) {
        var tag = document.getElementById('bbHeatData');
        raw = tag ? JSON.parse(tag.textContent || '{}') : {};
      }
      var arr = [], k;
      for (k in raw) {
        if (raw.hasOwnProperty(k) && raw[k] && typeof raw[k][0] === 'number') arr.push([k, raw[k][0]]);
      }
      arr.sort(function (a, b) { return a[1] - b[1]; });
      for (var i = 0; i < arr.length; i++) heatM[arr[i][0]] = arr.length > 1 ? i / (arr.length - 1) : 0.5;
    } catch (e) { heatM = {}; }
    return heatM;
  }
  function heat01(handle) {
    var v = heatMap()[handle];
    return typeof v === 'number' ? v : 0.35;   /* 查不到就当偏冷门 */
  }

  /* ---- 池子大小：热门卡池子小（抢得快、补得勤），冷门卡池子大 ----
     BB-STOCK-PUNCH-20261029：由 5~9 收到 **4~6**，显示区间随之从 2~10 压到 **2~7**。
     全场平均显示 ≈ 4.5 件 —— 每一张都在「快没了」的档位上，而不是一半在 8~10 的不痛不痒区。 */
  function poolSize(handle) {
    var p = 6 - Math.round(2 * heat01(handle));
    return p < 4 ? 4 : (p > 6 ? 6 : p);
  }

  /* ---- 对外：给定真实库存，返回「该显示几件」 ----
     🔴 BB-STOCK-PURE-20261029（侯哥 14:30：「前端库存只是一个渲染作用，一定要以后台真实调用的库存为主。
        举例：前端显示 3 张、实际还有 50 张，这时十个客户同时下单，都必须能成功；
        下单成功后前端渲染的 3 归零，系统要能快速把渲染数量补上去」）
     ----------------------------------------------------------------------
     这一版把「渲染」和「真实」彻底解开：

       真实库存（服务端）   → 唯一决定「能不能买、能买几件」
       渲染数字（本函数）   → 只决定「写几件」，绝不参与购买判定

     所以去掉了上一版那行 `if (v > q) v = q`（真实库存反过来压低渲染值）：
       真实库存 50 而池子算到 3 → 显示 3，客户照买不误（买 10 件也成功，因为服务端有 50）；
       真实库存从 50 掉到 5 → **显示值完全不变**（它只看 handle + 时间），不会跟着缩；
       真实库存真到 0 → 才 Sold out。

     只保留一个例外：真实库存 ≤ 2 时说真话（`STOCK_TRUTH`）。
     这时候卡马上要被 inv-sync 摘掉，说真话既准确也不损失什么。

     万一出现「显示 6 但实际只剩 3」：客户点加购 6 件，`stockGuard` 会用**真实库存**拦住
     并提示真实数量 —— 渲染数字从来不会让客户超买后才发现。 */
  function shown(handle, realQty, avail) {
    var q = parseInt(realQty, 10);
    if (isNaN(q)) q = 0;
    if (avail === false || avail === 'false' || !(q > 0)) return { q: 0, out: true };
    if (forceReal) return { q: q, out: false };
    var pool = poolSize(handle);
    var seed = Math.floor(h01(handle) * pool);
    var slot = Math.floor(Date.now() / TICK);
    var v = FLOOR + (pool - 1 - (((slot + seed) % pool) + pool) % pool);   /* 2 .. pool+1 */
    if (q <= STOCK_TRUTH) v = q;      /* 真实库存 ≤2：说真话 */
    if (v > CAP) v = CAP;
    return { q: v, out: false };
  }

  /* 文案：全站一套口径（<=LOW_AT 说 Only N left，否则 N in stock） */
  function text(handle, realQty, avail) {
    var r = shown(handle, realQty, avail);
    if (r.out) return 'Sold out';
    return r.q <= LOW_AT ? ('Only ' + r.q + ' left') : (r.q + ' in stock');
  }

  /* 扫描所有带 data-bbs-qty 的节点统一改写（Liquid 侧只负责把真值和 handle 挂上去） */
  function applyAll(root) {
    var list = (root || document).querySelectorAll('[data-bbs-qty]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.getAttribute('data-bbs-avail') === 'false') continue;   /* 售罄保持 Liquid 原样 */
      var r = shown(el.getAttribute('data-bbs-key') || '', el.getAttribute('data-bbs-qty'), true);
      if (r.out) continue;
      el.textContent = r.q <= LOW_AT ? ('Only ' + r.q + ' left') : (r.q + ' in stock');
      el.setAttribute('data-bbs-shown', r.q);
      el.classList.toggle('is-low', r.q <= LOW_AT);
    }
    /* 顺带把"限时/限量"角标的数量也压下来（若有 data-bbs-num） */
    var nums = (root || document).querySelectorAll('[data-bbs-num]');
    for (var j = 0; j < nums.length; j++) {
      var n = nums[j];
      var rr = shown(n.getAttribute('data-bbs-key') || '', n.getAttribute('data-bbs-num'), true);
      if (!rr.out) n.textContent = rr.q;
    }
  }

  window.BBStock = {
    shown: shown,
    text: text,
    apply: applyAll,
    lowAt: LOW_AT,
    isReal: function () { return forceReal; }
  };
})();
/* 兜底：万一某个列表后面漏了内联 apply，DOM 就绪时再统一扫一遍（幂等，不会变数） */
document.addEventListener('DOMContentLoaded', function () {
  try { if (window.BBStock && window.BBStock.apply) window.BBStock.apply(document); } catch (e) {}
});
